module.exports = __webpack_public_path__ + "img/arrow_up_circle.eb5eb7f4.svg";